// 主观题批阅-批阅
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool, component_tool } from '@/tool'
import columns from './columns'
import './index.less'

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizRow, WizCol, WizTypography, WizForm, WizButton, WizSpin, WizModal } = component_tool;
let { Session } = utils_tool
let { Text } = WizTypography


class ExaminationReview extends WizContainer {
    componentName = 'examinationReview';

    constructor(props) {
        super(props);
        const { history } = props
        // 将传值放入到state中
        let examinationReviewRecord = {};
        if (history.location && history.location.pathname === '/subjectiveReview/review') {
            examinationReviewRecord = Session.get('examinationReviewRecord') || {}
        }
        this.examinationReviewRecord = examinationReviewRecord
        this.continueReviewState = false // 保存并继续批阅
        this.state = {
            dataInfo: {}
        }
    }

    propsAndStateOnChange = {
        reviewInfo: this._reviewInfoChange.bind(this),
        confirmReview: this._confirmReviewChange.bind(this)
    }

    // 确认并继续 交互提示
    countDown() {
        let secondsToGo = 3;
        const modal = WizModal.success({
            title: '提示',
            content: `当前已没有可批阅任务,${secondsToGo}s后返回`,
            okText: '立即返回',
            onOk: () => {
                clearInterval(timer);
                modal.destroy();
                window.close()
            }
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            modal.update({
                content: `当前已没有可批阅任务,${secondsToGo}s后返回`,
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            modal.destroy();
            window.close()
        }, secondsToGo * 1000);
    }

    // 批阅
    _confirmReviewChange(nextProps, nextState) {
        let { confirmReview } = nextProps
        let { success, msg, data } = confirmReview
        if (success) {
            wizNotice.success(msg)
            if (this.continueReviewState) {
                this.continueReviewState = false
                let dataKeys = Object.keys(data)
                if (dataKeys.length === 0 || [null, undefined, -1].indexOf(data.id) !== -1) {
                    this.countDown()
                } else {// 确认并继续
                    // 将用户信息更换,防止刷新后数据丢失
                    Session.set('examinationReviewRecord', data.personInfo)
                    nextState.dataInfo = data
                }
            } else {
                setTimeout(() => {
                    window.close()
                }, 1000)
            }
            return true
        }
        wizNotice.error(msg || '批阅失败')
        return false
    }

    // 批阅信息
    _reviewInfoChange(nextProps, nextState) {
        let { reviewInfo } = nextProps
        let { success, msg, data } = reviewInfo
        if (success) {
            nextState.dataInfo = data
            if(data.noticeMsg) {
                wizNotice.warning(data.noticeMsg)
            }
            return true
        }
        wizNotice.error(msg || '获取批阅信息失败')
        return false
    }

    _componentDidMount() {
        this._getReviewInfo()
    }

    // 获取批阅信息 (只在第一次进入时获取)
    _getReviewInfo() {
        let { id, examId, paperId } = this.examinationReviewRecord
        this.doAction({
            path: 'examinationRecord/reviewInfo',
            payload: {
                key: 'reviewInfo',
                apiParams: {
                    id,
                    examId,
                    paperId
                }
            },
        })
    }

    _renderHeadCardInfo(personInfo) {
        let { fullName, orgName, orgCode, positionName } = personInfo
        return (
            <WizRow gutter={[15, 15]} type='flex' justify='space-around' align='middle'>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>姓名：</span>
                        <span className='head-font-style'>{fullName}</span>
                    </Text>
                </WizCol>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>组织名称：</span>
                        <span className='head-font-style'>{orgName}</span>
                    </Text>
                </WizCol>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>组织代码：</span>
                        <span className='head-font-style'>{orgCode}</span>
                    </Text>
                </WizCol>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>已选岗位：</span>
                        <span className='head-font-style'>{positionName}</span>
                    </Text>
                </WizCol>
            </WizRow>
        )
    }

    /**
     *
     * @param {*} continueState  true保存并继续 false 保存并返回
     */
    _save(continueState) {

        this.refs.form.validateFieldsAndScroll((errors, values) => {
            if (!errors) {
                let copyInfo = { ...this.state.dataInfo }
                // values[key] 绑定时通过题目id为key值,将内容取出,压入到评分字段中
                copyInfo.parts = copyInfo.parts.map(e => {
                    e.questions.map(q => {
                        q['obtainScore'] = values[q['id']]
                    })
                    return e
                })
                // 确认并继续
                if (continueState) {
                    this.continueReviewState = true
                    copyInfo.limitNum = 1
                }

                this.doAction({
                    path: 'examinationRecord/confirmReview',
                    payload: {
                        key: 'confirmReview',
                        apiParams: {
                            ...copyInfo
                        }
                    },
                })
            }
        })
    }

    _renderFormFooter() {
        let { dataInfo } = this.state
        if (Object.keys(dataInfo).length === 0) {
            return null
        }
        return (
            <WizRow type='flex' className='form-btn' justify='center' gutter={[30, 50]}>
                <WizCol>
                    <WizButton onClick={e => { window.close() }}>取消</WizButton>
                </WizCol>
                {
                    dataInfo.personInfo.state === 0 ? <WizCol>
                        <WizButton type='primary' onClick={() => { this._save(true) }}>确认并继续</WizButton>
                    </WizCol> : null
                }
                <WizCol>
                    <WizButton type='primary' onClick={() => { this._save() }}>确认并返回</WizButton>
                </WizCol>
            </WizRow>
        )
    }
    _render() {
        let { examinationRecordLoading } = this.props
        let { dataInfo } = this.state
        let formProps = {
            ref: 'form',
            columns: columns(dataInfo.parts || []),
            className: 'form-style',
            record: null,
            preview: null,
            footer: this._renderFormFooter(),
            formItemLayout: {
                labelCol: { span: 0 },
                wrapperCol: { span: 24 }
            }
        }
        return (
            <WizSpin spinning={examinationRecordLoading} >
                <div className='review-box'>
                    <WizCard title='学员信息' className={'review-box-base-info'}>
                        {dataInfo.personInfo ? this._renderHeadCardInfo(dataInfo.personInfo) : null}
                    </WizCard>
                    <WizCard title='批阅'>
                        <WizForm  {...formProps} />
                    </WizCard>
                </div>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { examinationRecord } = state
    const reviewInfo = modelUtils.getModelEntity(examinationRecord, 'reviewInfo')
    const confirmReview = modelUtils.getModelEntity(examinationRecord, 'confirmReview')
    const loading = modelUtils.getLoadingState(state, 'examinationRecord')
    return {
        reviewInfo,
        confirmReview,
        ...loading,
    }
};

export default connect(mapStateToProps)(ExaminationReview);
